export default __webpack_public_path__ + "static/logo-abt-dark-2e5fbf8ec7d6c5d01cece920d9b09ab1.png";